/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useDispatch, useSelector } = Redux;
import { navigate, useLocation } from '@reach/router';
import ClassNames from 'classnames';
const { selectCurrentCountry } = Slices.profileSlice;
const { selectProductEntities } = Slices.productSlice;
const { selectCountryValidations } = Slices.configSlice;
import Button from '@material-ui/core/Button';
import { generateProductRoute } from 'spwa-ui-library/esm/utils/path';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import css from './index.module.scss';
import { useIntl } from 'react-intl';

import noImg from '../../assets/no-itm.png';

const { selectDesktop } = Slices.appSlice;
const { selectDefaultAddress } = Slices.addressSlice;
const { getClusterId } = Slices.configSlice;
const { getProductInfo, fetchProductsByCategoryId } = Slices.productSlice;
const { addProductToCustomize } = Slices.tempCartSlice;

export default function ProductCard({
  product,
  // imgBaseUrl,
  className,
  productButtonTitle = 'XYZ',
  route,
  index,
}) {
  const productEntity = product;
  const dispatch = useDispatch();
  const location = useLocation();
  const clusterId = useSelector(getClusterId);
  const address = useSelector(selectDefaultAddress);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const categoryList = useSelector((state) => state.category);
  const productItems = useSelector(selectProductEntities);

  const isDesktop = useSelector(selectDesktop);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const intl = useIntl();
  const lang = intl.locale.split('-')[0].toLowerCase();
  const currency = lang !== 'en' ? countryValidations?.currencyAr : countryValidations?.currency;

  const handleNavigate = () => {
    let category = {};
    let locale = intl.locale;
    let productRoute = '';
    const productObj = JSON.parse(
      JSON.stringify(productItems[productEntity?.action?.id] || productEntity)
    );

    if (!productObj?.['assets'] || !productObj?.['id']) {
      productObj['assets'] = [{ src: productEntity['mediaUrl'] }];
      productObj['price'] = productEntity['originalPrice'];
      productObj['specialPrice'] = productEntity['originalPrice'];
      productObj['categories'] = [productEntity.action.category_id];
      productObj['id'] = productEntity.action.id;
      productObj['isHomePageItem'] = true;
      productObj['name'] = productEntity[`name_${intl.locale}`] || productEntity[`name_en`];
    }

    category = categoryList.entities[productEntity?.action?.category_id];
    productRoute = generateProductRoute({ product: productObj, category, locale });

    if (
      (productObj?.bundleTypeId === 'bundle' || productObj?.bundleTypeId === 'bundle_group') &&
      productObj?.typeId != 'simple'
    ) {
      productRoute = `${productRoute}/bundle`;
    }
    dispatch(
      fetchProductsByCategoryId({
        id: productEntity?.action?.category_id,
        cluster: clusterId,
        Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
      })
    ).then((p) => {
      dispatch(
        getProductInfo({
          id: productEntity?.action?.id,
          cluster: clusterId,
          service: address?.addressSubType || 'DELIVERY',
          categoryId: productEntity?.action?.category_id,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
        })
      ).then((resp) => {
        dispatch(
          addProductToCustomize({
            productType: resp?.payload?.bundleTypeId,
            updatedOn: new Date().getTime(),
            mainProductId: resp?.payload?.id,
            data: {
              ...resp?.payload,
              noIncrement: true,
            },
          })
        );
        navigate(productRoute, {
          state: {
            retUrl: `/${intl.locale}/home/`,
            oldLocation: location,
          },
        });
      });
    });
  };

  return productEntity ? (
    <div className={ClassNames({ [className]: className }, css.root)}>
      <div className={css.thumbnailContainer}>
        <img
          className={css.thumbnail}
          src={`${productEntity?.mediaUrl}`}
          onClick={() => {
            handleNavigate();
          }}
          alt={productEntity[`name_${intl.locale.toLowerCase()}`]}
          width="100"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noImg;
            e.target.width = '70';
          }}
        />
      </div>
      <h3 className={css.title}>{productEntity[`name_${intl.locale.toLowerCase()}`]}</h3>
      {isDesktop && <p className={css.description}>{productItems[index]?.longDesc}</p>}

      <div className={css.footer}>
        <span className={css.price}>
          {decimalChecker(productEntity.originalPrice)} {currency}
        </span>
        <Button variant="outlined" onClick={handleNavigate} color="primary" size="medium">
          {productButtonTitle}
        </Button>
      </div>
    </div>
  ) : (
    ''
  );
}
